"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalRoot = exports.BurgerMenuRoot = exports.BurgerMenuInner = exports.BurgerMenuContentRoot = exports.BurgerMenuContainer = exports.BurgerMenuBackdrop = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
var _styles = require("../styles");
var _constants2 = require("./constants");
const BurgerMenuContentRoot = exports.BurgerMenuContentRoot = (0, _mui.styled)('div')(() => ({}));
const ModalRoot = exports.ModalRoot = (0, _mui.styled)(_components.Modal)(({
  theme
}) => ({
  ..._styles.basePositionStyles,
  zIndex: theme.zIndex.drawer,
  display: 'block'
}));
const BurgerMenuRoot = exports.BurgerMenuRoot = (0, _mui.styled)('aside')(({
  ownerState,
  theme
}) => ({
  backgroundColor: theme.palette.common.white,
  display: 'none',
  transition: `top ${_constants.CSS_HEIGHT_ANIMATION}`,
  ...(ownerState.isMobile && {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxWidth: 'calc(100% - 45px)',
    position: 'absolute',
    width: 315
  }),
  ...(ownerState.isDesktop && {
    boxShadow: _mui.SHADOW_LEVEL1,
    display: 'flex',
    left: 0,
    minHeight: 590,
    position: 'absolute',
    top: _constants.CSS_DESKTOP_INNER_HEIGHT
  })
}));
const BurgerMenuInner = exports.BurgerMenuInner = (0, _mui.styled)('div')(({
  theme
}) => ({
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    width: 'inherit',
    maxHeight: `calc(100vh - ${_constants.DESKTOP_HEIGHT}px - ${_constants2.HEIGHT_BUFFER}px)`,
    overflowX: 'hidden',
    overflowY: 'auto'
  }
}));
const BurgerMenuContainer = exports.BurgerMenuContainer = (0, _mui.styled)('div')({
  display: 'flex',
  height: 54,
  width: '100%'
});
const BurgerMenuBackdrop = exports.BurgerMenuBackdrop = (0, _mui.styled)(_mui.Backdrop)({
  position: 'absolute',
  zIndex: '-1',
  width: '100vw',
  height: '100vh'
});
